//フローティングバナー
const intersectionContainer = document.querySelector(".js-inner");
const intersectionTarget = document.querySelector(".float-banner");
const infiniteScrollObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      intersectionTarget.classList.remove("is-shown");
    } else {
      intersectionTarget.classList.add("is-shown");
    }
  });
});
infiniteScrollObserver.observe(intersectionContainer);